<!-- =========================================================================================
  File Name: CompanyViewAddresses.vue
  Description: Entity Edit account content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-addresses-form">
    <div class="vs-row">
      <div class="vs-col w-full">
        <card-page card-title="Saved Addresses">
          <div :class="[
              'form-wrapper',
              showForm ? '' : 'empty-wrapper'
            ]"
          >
            <vue-form-generator
                class="mt-4 readonly-form addresses crud-additive-form"
                ref="addressesAdditiveForm"
                :model="model"
                :options="formOptions"
                :schema="schema"
            />
          </div>
        </card-page>
        <div class="flex justify-end add-button-wrapper">
          <vs-button v-if="showAddButton" @click="goToCreate">
            Add
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardPage from '../../../components/Views/CardPage';
import ViewModelMixin from '../../../../components/mixins/ViewModelMixin';
import NotificationMixin from '../../../../components/mixins/NotificationMixin';
import { selectOptions, arrayOptions } from '@/components/form/FormElementOption';
import CanAccessMixin from '../../../../components/mixins/CanAccessMixin';


export default {
  components: {
    CardPage
  },
  mixins: [ViewModelMixin, NotificationMixin, CanAccessMixin],
  data () {
    return {
      componentAccess: {
        canCreate: {
          route: 'company.addresses.create',
          access: false,
        },
      },
      model: {
        addresses: [],
      },
      schema: {
        groups: [
          {
            styleClasses: 'text-black',
            fields: [
              {
                model: 'addresses',
                ...arrayOptions,
                hideAddButton: true,
                showRemoveButton: false,
                items: {
                  type: 'object',
                  schema: {
                    groups: [
                      {
                        styleClasses: 'w-11/12 content flex flex-wrap items-end',
                        fields: [
                          {
                            type: 'label',
                            visible: (model) => model && !model.IsPrimaryAddress,
                            styleClasses: 'w-1/2 m-0 py-4 is-secondary-label',
                            label: 'Secondary',
                          },
                          {
                            type: 'pillButton',
                            styleClasses: 'w-1/2 m-0 py-4 set-primary-button flex justify-end',
                            buttonText: 'Set as primary',
                            fieldClasses: 'pointer',
                            onClick: (model) => {
                              this.setAsPrimary(model.id)
                            },
                            visible: (model) => model && !model.IsPrimaryAddress,
                          },
                          {
                            type: 'label',
                            visible: (model) => model && model.IsPrimaryAddress,
                            styleClasses: 'w-1/2 m-0 py-4 is-primary-label',
                            label: 'Primary',
                          },
                          {
                            type: 'pillButton',
                            styleClasses: 'w-1/2 m-0 py-4 is-primary-button flex justify-end',
                            buttonText: 'Primary',
                            buttonColor: 'success',
                            disabled: true,
                            fieldClasses: 'text-white',
                            visible: (model) => model && model.IsPrimaryAddress,
                          },
                          {
                            disabled: () => this.readonly,
                            type: 'label',
                            styleClasses: 'w-full text-xl mt-4 py-0 mb-0',
                            label: 'Address',
                          },
                          {
                            disabled: true,
                            type: 'input',
                            inputType: 'text',
                            styleClasses: 'w-full m-0 pb-0 pt-4',
                            model: 'AddressLineFirst',
                          },
                          {
                            disabled: true,
                            type: 'input',
                            inputType: 'text',
                            styleClasses: 'w-full m-0 py-0',
                            model: 'AddressLineSecond',
                          },
                          {
                            disabled: true,
                            type: 'input',
                            inputType: 'text',
                            styleClasses: 'w-full m-0',
                            model: 'AddressLineThird',
                          },
                          {
                            disabled: () => this.readonly,
                            visible: function(model) {
                              return model && model.phone_number && model.phone_number.PhoneNumber;
                            },
                            type: 'label',
                            styleClasses: 'w-full text-xl mt-4 py-0 mb-4',
                            label: 'Primary Phone Number',
                          },
                          {
                            disabled: true,
                            visible: function(model) {
                              return model && model.phone_number && model.phone_number.PhoneNumber;
                            },
                            type: 'input',
                            inputType: 'text',
                            styleClasses: 'w-2/12 m-0',
                            label: 'Country Code',
                            model: 'phone_number.CountryCode',
                          },
                          {
                            disabled: true,
                            visible: function(model) {
                              return model && model.phone_number && model.phone_number.PhoneNumber;
                            },
                            type: 'input',
                            inputType: 'text',
                            styleClasses: 'w-3/12 m-0',
                            label: 'Phone Number',
                            model: 'phone_number.PhoneNumber',
                          },
                          {
                            disabled: true,
                            visible: function(model) {
                              return model && model.phone_number && model.phone_number.PhoneNumber;
                            },
                            type: 'input',
                            inputType: 'text',
                            styleClasses: 'w-2/12 m-0',
                            label: 'Phone Extension',
                            model: 'phone_number.PhoneExtension',
                          },

                          {
                            model: 'phone_numbers',
                            styleClasses: 'phone_numbers_child_additive',
                            ...arrayOptions,
                            hideAddButton: true,
                            showRemoveButton: false,
                            items: {
                              type: 'object',
                              schema: {
                                groups: [
                                  {
                                    styleClasses: 'w-full content',
                                    fields: [
                                      {
                                        disabled: () => this.readonly,
                                        type: 'label',
                                        styleClasses: 'w-full text-xl mt-4 py-0 mb-4',
                                        label: 'Secondary Phone Numbers',
                                      },
                                      {
                                        disabled: true,
                                        type: 'input',
                                        inputType: 'text',
                                        styleClasses: 'w-2/12',
                                        label: 'Country Code',
                                        model: 'CountryCode',
                                      },
                                      {
                                        disabled: true,
                                        type: 'input',
                                        inputType: 'text',
                                        styleClasses: 'w-3/12',
                                        label: 'Phone Number',
                                        model: 'PhoneNumber',
                                      },
                                      {
                                        disabled: true,
                                        type: 'input',
                                        inputType: 'text',
                                        styleClasses: 'w-2/12',
                                        label: 'Phone Extension',
                                        model: 'PhoneExtension',
                                      },
                                    ]
                                  }
                                ]
                              }
                            }
                          },
                        ]
                      },
                      {
                        styleClasses: 'w-1/12 crud-buttons flex',
                        fields: [
                          {
                            type: 'awesomeButton',
                            styleClasses: 'awesome-form-button edit',
                            buttonOptions: {
                              route: {
                                name: 'company.addresses.edit',
                                routeParam: 'addressId',
                              },
                              icon: {
                                prefix: 'fal',
                                iconName: 'pencil'
                              },
                            },
                          },
                          {
                            type: 'awesomeButton',
                            styleClasses: 'awesome-form-button delete',
                            buttonOptions: {
                              icon: {
                                prefix: 'fal',
                                iconName: 'times'
                              },
                            },
                            onClick: async (model) => {
                              this.confirmDeleteAddress(model);
                            }
                          }
                        ]
                      },
                    ]
                  }
                }
              },
            ]
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
    }
  },
  computed: {
    showForm() {
      return this.model.addresses
          ? this.model.addresses.length
          : false;
    },
    id() {
      return this.$route.params.id;
    },
    showAddButton() {
      return this.componentAccess.canCreate.access;
    }
  },
  methods: {
    confirmDeleteAddress(addressModel) {
      if (addressModel.IsPrimaryAddress) {
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: 'Cannot delete a primary address',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-right'
        })

        return;
      }

      const deleteAddress = async () => {
        try {
          await this.$api.companyAddress.delete(addressModel.id);
          this.$vs.notify({
            color: 'success',
            title: 'Address Deleted',
            position: 'top-right',
            text: 'The selected address was successfully deleted'
          })
          await this.fetch()
        } catch (e) {
          this.$vs.notify({
            color: 'danger',
            title: 'Error occurred',
            text: 'Not able to delete address. Please try again.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-right'
          })
        }
      };

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete this address`,
        accept: deleteAddress,
        acceptText: 'Delete'
      })
    },
    async setAsPrimary(addressId) {
      this.loading = true;

      try {
        // Doing this here makes it feel more responsive
        this.model.addresses.forEach((address) => {
          address.IsPrimaryAddress = 0;

          if (address.id === addressId) {
            address.IsPrimaryAddress = 1;
          }
        })

        await this.$api.companyAddress.setPrimary(addressId);
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          color: 'error',
          title: 'Address not set as Primary Address',
          text: 'An error has occured. Please try again later',
          position: 'top-right'
        })
        return false;
      } finally {
        this.loading = false;
        this.$vs.notify({
          color: 'success',
          title: 'Address Set as Primary Address',
          text: 'The selected address was set as the primary address',
          position: 'top-right'
        })
      }
    },
    goToCreate() {
      this.$router.push({ name: 'company.addresses.create' })
    },
    async fetch() {
      try {
        const {data} = await this.$api.companies.relationship('addresses', this.id);

        if (data.data.length) {
          await data.data.forEach((address) => {
            address.AddressLineFirst = address.AddressLine1;
            address.AddressLineFirst += address.AddressLine2 ? ', ' + address.AddressLine2 : '';
            address.AddressLineFirst += address.AddressLine3 ? ', ' + address.AddressLine3 : '';

            address.AddressLineSecond = address.City ? address.City + ', ' : '';
            address.AddressLineSecond += address.Region ? address.Region + ', ' : '';
            address.AddressLineSecond += address.Province ? address.Province : '';

            address.AddressLineThird = address.PostCode ? address.PostCode + ', ' : '';
            address.AddressLineThird += address.Country ? address.Country : '';

            address.phone_numbers = address.phone_numbers.filter((number) => number.IsPrimaryNumber == 0)
          });
        }

        this.model.id = this.id;
        this.model.addresses = data.data;
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve addresses. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
  }

}
</script>
